import React, { useEffect, useState } from 'react';
import Hero8 from '../Hero/Hero8';
import { Link } from 'react-router-dom';
import ServiceListStyle2 from '../ServiceList/ServiceListStyle2';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Portfolio from '../Portfolio';
import Div from '../Div';
import { pageTitle } from '../../helper';
import { Icon } from '@iconify/react';
import TestimonialSlider from '../Slider/TestimonialSlider';
import VideoModal from '../VideoModal';
import Cta from '../Cta';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import PortfolioSlider2 from '../Slider/PortfolioSlider2';
const heroSocialLinks = [
  {
    name: 'Instagram',
    links: 'https://www.instagram.com/justchargemedia/',
  },
  {
    name: 'Linkedin',
    links: 'https://www.linkedin.com/company/justchargemedia/posts/?feedView=all',
  },
];


const accordionData = [
  {
    question: 'What’s the difference between UX and UI design?',
    answer:
      'UX (User Experience) focuses on how users interact with your platform, ensuring ease and satisfaction. UI (User Interface) deals with visual elements, making the platform aesthetically appealing. Together, they create seamless digital experiences.',
  },
  {
    question: 'How does a well-designed UX/UI impact my business?',
    answer:
      'A great design enhances user engagement, reduces bounce rates, increases conversions, and ensures customer satisfaction—turning visitors into loyal customers.',
  },
  {
    question: 'Can you redesign my existing website or app?',
    answer:
      'Absolutely! We analyze user behavior and identify pain points to revamp your digital platform, improving usability and engagement.',
  },
  {
    question: 'Do you follow user research while designing?',
    answer:
      'Yes, we conduct thorough user research, usability testing, and A/B testing to create designs that truly resonate with your audience.',
  },
  {
    question: 'How long does a UX/UI design project take?',
    answer:
      'It depends on the complexity, but typically, UX/UI design takes 4-8 weeks for a complete, research-backed solution.',
  },
];

const CustomAccordion = () => {
  const [selected, setSelected] = React.useState(null);
  const handelToggle = index => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  return (
    <Div className="cs-accordians cs-style1">
      {accordionData.map((item, index) => (
        <Div
          className={`cs-accordian ${selected === index ? 'active' : ''}`}
          key={index}
        >
          <Div
            className="cs-accordian_head"
            onClick={() => handelToggle(index)}
          >
            <h2 className="cs-accordian_title">{item.question}</h2>
            <span className="cs-accordian_toggle cs-accent_color">
              <svg
                width={15}
                height={8}
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
              </svg>
            </span>
          </Div>
          {selected === index && (
            <Div className="cs-accordian_body">
              <Div className="cs-accordian_body_in">{item.answer}</Div>
            </Div>
          )}
        </Div>
      ))}
    </Div>
  );
};

const portfolioData = [
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de1.png',
    category: 'ui_ux_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de2.png',
    category: 'logo_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de3.png',
    category: 'web_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de4.png',
    category: 'mobile_apps',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de5.png',
    category: 'ui_ux_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de6.png',
    category: 'web_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de7.png',
    category: 'logo_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de8.png',
    category: 'ui_ux_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de9.png',
    category: 'logo_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de10.png',
    category: 'web_design',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/de11.png',
    category: 'web_design',
  },
];
const categoryMenu = [
  {
    title: 'Web Design',
    category: 'web_design',
  },
  {
    title: 'UI/UX Design',
    category: 'ui_ux_design',
  },
  {
    title: 'Mobile Apps',
    category: 'mobile_apps',
  },
  {
    title: 'Logo Design',
    category: 'logo_design',
  },
];

const serviceData = [
  {
    title: 'Research & Discovery',
    subtitle:
      'Analyzing user behavior & pain points to create data-driven solutions.',
    imgUrl: '/images/dep1.png',
    href: '/service',
  },
  {
    title: 'Wireframing & Prototyping',
    subtitle:
      'Structuring seamless user journeys with interactive prototypes.',
    imgUrl: '/images/dep2.png',
    href: '/service',
  },
  {
    title: 'Visual & Interaction Design',
    subtitle:
      'Crafting intuitive, aesthetically pleasing experiences for users.',
    imgUrl: '/images/dep3.png',
    href: '/service',
  },
  {
    title: 'User Testing & Feedback',
    subtitle:
      'Ensuring the design aligns with user expectations through validation.',
    imgUrl: '/images/dep4.png',
    href: '/service',
  },
  {
    title: 'Final Implementation',
    subtitle:
      'Integrating and optimizing the user experience across digital platforms.',
    imgUrl: '/images/dep5.png',
    href: '/service',
  },
];

const ServiceList = ({ variant }) => {
  const [active, setActive] = useState(0);
  const handelActive = index => {
    setActive(index);
  };
  return (
    <Div className={`cs-iconbox_3_list ${variant ? variant : ''}`}>
      {serviceData.map((item, index) => (
        <Div
          className={`cs-hover_tab ${active === index ? 'active' : ''}`}
          key={index}
          onMouseEnter={() => handelActive(index)}
        >
          <Link to={item.href} className="cs-iconbox cs-style3">
            <>
              <Div className="cs-image_layer cs-style1 cs-size_md">
                <Div className="cs-image_layer_in">
                  <img
                    src={item.imgUrl}
                    alt="Thumb"
                    className="w-100 cs-radius_15"
                  />
                </Div>
              </Div>
              <span className="cs-iconbox_icon cs-center">
                <svg
                  width={30}
                  height={29}
                  viewBox="0 0 30 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.3803 3.05172C29.4089 1.94752 28.537 1.02921 27.4328 1.00062L9.43879 0.534749C8.33459 0.506159 7.41628 1.37811 7.38769 2.48231C7.35911 3.58651 8.23106 4.50482 9.33526 4.53341L25.3299 4.94752L24.9158 20.9422C24.8872 22.0464 25.7592 22.9647 26.8634 22.9933C27.9676 23.0218 28.8859 22.1499 28.9144 21.0457L29.3803 3.05172ZM3.37714 28.5502L28.7581 4.4503L26.0039 1.54961L0.622863 25.6495L3.37714 28.5502Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <Div className="cs-iconbox_in">
                <h2 className="cs-iconbox_title">{item.title}</h2>
                <Div className="cs-iconbox_subtitle">{item.subtitle}</Div>
              </Div>
            </>
          </Link>
        </Div>
      ))}
    </Div>
  );
};

export default function FreelancerAgencyHome() {
  pageTitle('Portfolio');
  const [active, setActive] = useState('all');
  const [itemShow, setItemShow] = useState(6);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Hero8
        title="Seamless Designs That Engage, Convert & Retain"
        subtitle="We craft immersive designs that captivate, engage, and convert. From intuitive UX to stunning visuals, we create experiences that leave a lasting impact."
        btnLink="/contact"
        btnText="Let's Create Magic Together"
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="/images/hero_bg_5.jpeg"
        bannerHighlightText="A"
        spiningCircleUrl="/images/hero_img.svg"
      />
      <section className="cs-shape_wrap_4 cs-parallax">
        {/* <div className="cs-shape_4 cs-to_up" />
        <div className="cs-shape_4 cs-to_right" /> */}

        <Spacing lg="70" md="45" />
        <ServiceList />
      </section>


      {/* <Spacing lg="90" md="70" />
      <PortfolioSlider2 /> */}
      <Spacing lg="115" md="55" />
      <Div className="container">
        <Div className="cs-portfolio_1_heading">
          <SectionHeading title="Some recent work" subtitle="Our Portfolio" />
          <Div className="cs-filter_menu cs-style1">
            <ul className="cs-mp0 cs-center">
              <li className={active === 'all' ? 'active' : ''}>
                <span onClick={() => setActive('all')}>All</span>
              </li>
              {categoryMenu.map((item, index) => (
                <li
                  className={active === item.category ? 'active' : ''}
                  key={index}
                >
                  <span onClick={() => setActive(item.category)}>
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </Div>
        </Div>
        <Spacing lg="90" md="45" />
        <Div className="cs_portfolio_grid_2">
          {portfolioData.slice(0, itemShow).map((item, index) => (
            <Div
              className={`${active === 'all'
                ? ''
                : !(active === item.category)
                  ? 'd-none'
                  : ''
                }`}
              key={index}
            >
              <Portfolio
                title={item.title}
                subtitle={item.subtitle}
                href={item.href}
                src={item.src}
                variant="cs-style1 cs-type1"
              />
            </Div>
          ))}
        </Div>

        <Div className="text-center">
          {portfolioData.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span
                className="cs-text_btn"
                onClick={() => setItemShow(itemShow + 4)}
              >
                <span>Load More</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>
      <Spacing lg="145" md="80" />
      {/* Start Testimonial Section */}
      <TestimonialSlider />
      {/* End Testimonial Section */}

      {/* Start Video Block Section */}
      <Spacing lg="140" md="70" />
      <Div className="container">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4">
          Great brands aren’t found, they’re built. Let’s craft, innovate, and scale your vision into reality!
        </h2>
        {/* <Spacing lg="70" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/watch?v=VcaAVWtP48A"
          bgUrl="/images/video_bg_2.jpeg"
        /> */}
      </Div>
      {/* End Video Block Section */}


      <Spacing lg='145' md='80' />
      <Div className="container cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-5 col-lg-6">
              <SectionHeading
                title='Some Pre Questions And Answers'
                subtitle='FAQs/Resources'
              />
              <Spacing lg='90' md='45' />
            </Div>
            <Div className="col-lg-6 offset-xl-1">
              <CustomAccordion />
            </Div>
          </Div>
        </Div>
      </Div>

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Brands we have worked with" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let&apos;s Build The <br />Next Big Thing Together!"
          btnText="Your Next Big Move Starts Here!"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
